let initList = [
  {
    name: "订单融资",
    explain:
      "买卖双方采用非信用证方式结算并已签署订单后，金融机构以订单项下的预期销售货款作为主要还款来源，为满足卖方在货物发运前因支付原材料采购款、组织生产、货物运输等资金需求而向其提供的短期融资。",
    imgUrl: "one.png",
    rateRangeLeft: "3.75",
    rateRangeRight: "5.00",
    monthRange: "1~12个月",
    moneyRange: "0~3000万",
    data: [
      "1、适用于与买方签订采用非信用证方式的订单的卖方;",
      "2、依法核准登记，具有法人营业执照或其他足以证明其经营合法和经营范围的有效证明文件;",
      "3、拥有合法、合理的商品交易合同；"
    ]
  },
  {
    name: "保理融资",
    explain:
      "国内的卖方在非信用证结算方式下赊销商品或服务后，将其合法拥有的应收账款债权转让给提供保理（保付代理）方，保理方向应收账款企业提供集应收账款催收、管理、坏账担保及融资于一体的综合型金融服务。",
    imgUrl: "two.png",
    rateRangeLeft: "3.75",
    rateRangeRight: "5.00",
    monthRange: "1~12个月",
    moneyRange: "0~3000万",
    data: [
      "1、适用于非信用证结算方式下，希望提前实现资金回笼，减轻应收账款管理与催收负担的卖方；",
      "2、依法核准登记，交易合法有效，买卖双方约定以赊销或延期付款方式进行结算；",
      "3、卖方有效履行合同义务，应收账款形成、权属清楚且未被转让、质押等；"
    ]
  },
  {
    name: "保函融资",
    explain:
      "保涵融资特指非融资类保函，包括贸易及工程项下的投标保函、履约保函、预付款保函、质量保函、维修保函和付款保函。主要用于满足工程承包方自工程项目招标开始，至工程结束整个活动过程中的担保需要。",
    imgUrl: "three.png",
    rateRangeLeft: "3.75",
    rateRangeRight: "5.00",
    monthRange: "1~12个月",
    moneyRange: "0~3000万",
    data: [
      "1、指定金融机构开立结算账户；",
      "2、资信状况良好，具有履行合同、偿还债务的能力；",
      "3、具有真实、合法的交易背景，主合同条款完备，责任明确；",
      "4、按规定需要提供保证金和/或反担保的，能够提供符合要求的保证金和/或反担保；"
    ]
  },
  {
    name: "投标保证金融资",
    explain:
      "主要依据融资企业与核心企业（包括国企、央企及大型企业、大型机构等）稳定的贸易合同关系，对企业的中标保证金给予一定比例的融资，帮助企业解决日常经营资金问题。",
    imgUrl: "four.png",
    rateRangeLeft: "3.75",
    rateRangeRight: "5.00",
    monthRange: "1~12个月",
    moneyRange: "0~3000万",
    data: [
      "1、从事业务相关经营活动6个月(含)以上，主要提供交易合同信息，且至少提供6个月(含)以上的稳定交易数据；",
      "2、申请融资方 (含法定代表人或实际控制人) 无不良信用记录，融资无逾期、欠息或垫款，未发生重大贸易纠纷、诉讼或其他重大事端；"
    ]
  }
];
export { initList };



// WEBPACK FOOTER //
// ./src/util/initList.js